export const allSimilarTravelers = state => state.allSimilarTravelers
export const similarTravelerDetail = state => state.similarTravelerDetail
